import React, { Component, useState } from "react";
import {
  Card,
  Row,
  Col,
  Button,
  Input,
  Form,
  FormGroup,
} from "react-bootstrap";
import InputFields from "../../shared/utilities/InputFields";
import states from "../../shared/data/States";

const requestorTypeOptions = [
  {
    value: "G",
    label:
      "Generator (A person or company who has waste on their site, facility, etc.)",
  },
  {
    value: "R",
    label: `Requestor (A 3rd party person or company that handles waste for a "generator")`,
  },
];

const siteTypeOptions = [
  { value: "B", label: "Business" },
  { value: "H", label: "Household" },
];

const reasonOptions = [
  { value: "B", label: "Abandoned Waste" },
  { value: "H", label: "Asbestos Abatement" },
  { value: "H", label: "Cleanup Property" },
  { value: "H", label: "One-time Cleanup" },
  { value: "H", label: "Other" },
];

export default function RequestorInfo(props) {
  const copyAddress = (fromType, toType) => {
    props.setFieldValue(
      [toType + "Street1"],
      props.values[fromType + "Street1"]
    );
    props.setFieldValue(
      [toType + "Street2"],
      props.values[fromType + "Street2"]
    );
    props.setFieldValue([toType + "State"], props.values[fromType + "State"]);
    props.setFieldValue([toType + "City"], props.values[fromType + "City"]);
    props.setFieldValue([toType + "Zip"], props.values[fromType + "Zip"]);
  };

  return (
    <Card className="tempid-card">
      <Card.Header>
        <i className="fa fa-align-justify"></i>
        <strong>Requestor Information</strong>
        <div className="card-header-actions"></div>
      </Card.Header>
      <Card.Body>
        <Row className="px-1">
          <InputFields
            initialFormValues={props.values}
            setFieldValue={props.setFieldValue}
            name="requestorType"
            config={{
              label: "I am the...",
              placeholder: "",
              type: "select2",
              data: requestorTypeOptions,
              col: "xs",
              colWidth: "4",
            }}
            values={props.values}
            handleChange={props.onChange}
            errors={props.errors}
            touched={props.touched}
            readOnly={props.readOnly}
          />
          <InputFields
            initialFormValues={props.values}
            setFieldValue={props.setFieldValue}
            name="siteType"
            config={{
              label: "This site is a...",
              placeholder: "",
              type: "select2",
              data: siteTypeOptions,
              col: "xs",
              colWidth: "4",
            }}
            values={props.values}
            handleChange={props.onChange}
            errors={props.errors}
            touched={props.touched}
            readOnly={props.readOnly}
          />
          <InputFields
            initialFormValues={props.values}
            setFieldValue={props.setFieldValue}
            name="applicationReason"
            config={{
              label: "Reason for Application",
              placeholder: "",
              type: "select2",
              hasApi: true,
              apiEndpoint: `api/v1/hwts/tempid/reasons`,
              col: "xs",
              colWidth: "4",
            }}
            values={props.values}
            handleChange={props.onChange}
            errors={props.errors}
            touched={props.touched}
            readOnly={props.readOnly}
          />
        </Row>
        <Row className="px-1"></Row>
      </Card.Body>
    </Card>
  );
}
